import { HttpService } from "./HttpService";
import { URL } from "enum";
import qs from "qs";

const URL_API = URL.VACACIONES;

const VacacionesService = {
	async getDetalleVacacionesDelColaborador() {
		const respuesta = await HttpService(URL_API).get("/control-vacacional/colaborador");
		return respuesta.data;
	},
	async simularDescontarDias(body) {
		const respuesta = await HttpService(URL_API).post("/control-vacacional/simular-descontar-dias", body);
		return respuesta.data;
	},
};

const SolicitudAusenciaService = {
	async listar() {
		const respuesta = await HttpService(URL_API).get("/solicitud");
		return respuesta.data;
	},

	async crear(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud", body);
		return respuesta.data;
	},

	async listarPorJefeInmediato(params) {
		const respuesta = await HttpService(URL_API).get("/solicitud/jefeinmediato", {
			params: params,
		});
		return respuesta.data;
	},

	async aprobarPorJefeInmediato(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/jefeinmediato/aprobar", body);
		return respuesta.data;
	},

	async aprobarMasivamentePorJefeInmediato(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/jefeinmediato/aprobar-masivo", body);
		return respuesta.data;
	},

	async rechazarPorJefeInmediato(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/jefeinmediato/rechazar", body);
		return respuesta.data;
	},
	async listarHistoricoPorJefeInmediato() {
		const respuesta = await HttpService(URL_API).get("/solicitud/jefeinmediato/listarHistoricoSolicitudesAusencia");
		return respuesta.data;
	},
	async buscarHistoricoPorJefeInmediato(params) {
		const respuesta = await HttpService(URL_API).get("/solicitud/jefeinmediato/historico/buscar", { params });
		return respuesta.data;
	},
	async listarOpcionesHistoricoPorJefeInmediato() {
		const respuesta = await HttpService(URL_API).get("/solicitud/jefeinmediato/historico/opciones");
		return respuesta.data;
	},
	async exportarHistoricoPorJefeInmediato(params) {
		const respuesta = await HttpService(URL_API).get("/solicitud/jefeinmediato/historico/exportarExcel", {
			params,
			responseType: "blob",
		});
		return respuesta;
	},
	async obtenerUrl(empresaId, solicitudId, plataforma) {
		const respuesta = await HttpService(URL_API).get(
			`/solicitud/jefeinmediato/solicitudId/${solicitudId}/empresa/${empresaId}/plataforma/${plataforma}/url`
		);
		return respuesta.data;
	},
	async obtenerDatosSolicitudAusencia(params) {
		const respuesta = await HttpService(URL_API).get("/solicitud/obtener-datos-solicitud-ausencia", {
			params: params,
		});
		return respuesta.data;
	},

	async verDocumentoAdjunto(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/jefeinmediato/verDocumentoAdjunto", body);
		return respuesta.data;
	},
	async cancelarSolicitud(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/cancelar", body);
		return respuesta.data;
	},
	async registrarSolicitud(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/registrar/portal-colaborador", body);
		return respuesta.data;
	},
	async listarHistorialCambioGrupo(colaboradorDni) {
		const respuesta = await HttpService(URL_API).get("/solicitud/historial-cambio-grupo", {
			params: { colaboradorDni },
		});
		return respuesta.data;
	},
	async listarMovimientosRegistradosPorAprobador() {
		const respuesta = await HttpService(URL_API).get("/solicitud/listarMovimientosRegistradosPorAprobador/portal-colaborador");
		return respuesta.data;
	},
	async obtenerAcumuladoDescansoMedico() {
		const respuesta = await HttpService(URL_API).get("/solicitud/acumulado-descanso-medico");
		return respuesta.data;
	},
	async simularDescansoMedico(diasSolicitados) {
		const respuesta = await HttpService(URL_API).get("/solicitud/simular-descanso-medico", {
			params: { diasSolicitados },
		});
		return respuesta.data;
	},
	async listarTiposEnfermedad() {
		const respuesta = await HttpService(URL_API).get("/solicitud/tipos-enfermedad");
		return respuesta.data;
	},
	async guardarTipoEnfermedad(body) {
		const respuesta = await HttpService(URL_API).post("/solicitud/guardar-tipo-enfermedad", body);
		return respuesta.data;
	},
};

const BloqueoMovimientosService = {
	async obtener() {
		const respuesta = await HttpService(URL_API).get("/bloqueo-movimientos");
		return respuesta.data;
	},
};

const TiposAusenciaService = {
	async listar() {
		const respuesta = await HttpService(URL_API).get("/tipos");
		return respuesta.data;
	},
	async buscarPorId(tipoAusenciaId) {
		const respuesta = await HttpService(URL_API).get("/tipos/" + tipoAusenciaId);
		return respuesta.data;
	},
	async listarPorPermisoRegistro(params) {
		const respuesta = await HttpService(URL_API).get("/tipos/listarPorPermisoDeRegistro", {
			params: params,
		});
		return respuesta.data;
	},
};

const JefeInmediatoService = {
	async listarColaboradores(params) {
		const respuesta = await HttpService(URL_API).get("/jefeinmediato/equipo", {
			params: params,
		});
		return respuesta.data;
	},
	async exportarSaldoReporteExcel(params) {
		const respuesta = await HttpService(URL_API).get("/jefeinmediato/exportarSaldoReporteExcel", {
			params: params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: "repeat" });
			},

			responseType: "blob",
		});
		return respuesta;
	},
	 async programarVacacionesFromColaborador(body) {
		const respuesta = await HttpService(URL_API).post("/jefeinmediato/programarVacacionesFromPortalColaborador", body);
		return respuesta.data;
	},
	 async listarProgramacionVacacionesPorEquipo(params) {
		const respuesta = await HttpService(URL_API).get("/jefeinmediato/programacionVacaciones/equipo", {
			params: params,
		});
		return respuesta.data;
	},
};

export { VacacionesService, SolicitudAusenciaService, TiposAusenciaService, JefeInmediatoService, BloqueoMovimientosService };
